var gmaps = {};
if (typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
    gmaps = require('./torque');
    gmaps.GMapsTileLoader = require('./gmaps_tileloader_mixin');
}
module.exports = gmaps;



//////////////////
// WEBPACK FOOTER
// ./~/torque.js/lib/torque/gmaps/index.js
// module id = 1739
// module chunks = 6